import React from "react";
import { Card } from "react-bootstrap";
import "./tehnologyManagement.scss";

const TehnologyManagementCardContent = () => {
  const cardContent = [
    {
      title: "Developing and maintaining your public web presence",
    },
    {
      title: "Managing content updates for public and members’ websites",
    },
    {
      title:
        "Implementing and configuring secure SaaS association management technology solutions for managing your organization’s membership and automating financial transactions",
    },
    {
      title:
        "Providing secure collaboration systems for members and their committee work, including discussion forums, document management, balloting, shared calendars, action item tracking, management of group rosters and comment tracking",
    },
    {
      title:
        "Performing contract and issue management with web hosting companies and solutions providers",
    },
    {
      title: "Providing web traffic data reports",
    },
    {
      title: "Posting and managing corporate documents",
    },
    {
      title:
        "Managing online event registration systems to plan and monetize association events",
    },
    {
      title: "Developing mobile applications to drive member engagement",
    },
    {
      title: "Providing Search Engine Optimization to increase exposure",
    },
  ];

  return (
    <div className="tehnology-content-container">
      <div className="tehnology-text-container">
        <p>
          Here are Cube Global we know that for many companies, their website is
          the chief way that their customers engage with the organisation. As
          the primary touch-point for your customers, your website’s
          functionality and user experience are critical, and our association
          technology management services can help.
        </p>
        <p>
          We build and maintain public websites, secure membership and
          collaboration sites, online registration, web content management
          systems and mobile applications. We also give you the data to better
          understand your members, their activities, interactions and
          engagement.
        </p>
      </div>

      <div className="tehnology-cards-container">
        <p className="text-title">
          Our Association Technology Management Services Include:
        </p>
        <div className="cards">
          {cardContent.map((card, index) => (
            <Card
              key={index}
              className="card"
            >
              <Card.Body
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  padding: "29px",
                }}
                className="card-content"
              >
                <Card.Text>
                  {" "}
                  <strong className="card-title">{card.title}</strong>
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TehnologyManagementCardContent;
